<template>
  <div>
    <h3 class="fw-bold">Переменные</h3>

    <div class="mt-2 mb-4">
      <HelpInfo>
        <span>Расположение функционала <span class="fw-bold">"Боты" - "Ваш бот" - "Переменные"</span></span>
      </HelpInfo>

      <p class="mt-3 mb-1">
        <span class="fw-bold">Переменные</span> - это контейнеры в которых хранятся данные, у переменной есть следующие характеристики:
      </p>

      <ul class="ms-3">
        <li><span class="fw-bold">Название</span> - просто название для более удобной работы с переменной</li>
        <li><span class="fw-bold">Код</span> - используется при подстановке переменной в сообщении или при передаче в HTTP запросах</li>
        <li><span class="fw-bold">Значение</span> - собственно само значение хранимое в переменной</li>
        <li><span class="fw-bold">Тип данных</span> - числовой, строковый</li>
        <li><span class="fw-bold">Тип</span> - глобальная или персональная</li>
      </ul>

      <p>
        При добавлении бота в конструктор, автоматически создаются некоторые переменные которые называются системными,
        например: <span class="fw-bold">_user_link_to_profile</span>, <span class="fw-bold">_bot_name</span>, <span class="fw-bold">_current_datetime</span> и т.д.
        Их значения контролирует конструктор, нет возможности поменять их значение из сценария, триггеров и т.д.
        Переменные создаваемые автором бота называются пользовательскими.
      </p>

      <p>
        Так же переменные делятся по типу на глобальные или персональные. Отличие в том в рамках чего просходит хранение значения переменной,
        если у каждого пользователя бота значение переменной может быть своим (например - количество заказов этого пользователя), то это персональная переменная.

        Если же значение распространяется на всех пользователей бота, то это глобальная переменная - например глобальный счетчик заказов всех клиентов.
      </p>

      <div class="">
        <Image
            class="d-flex justify-content-center"
            src="/docs_context.png"
            preview
            :image-style="{
              display: 'block',
              height: '200px',
              maxWidth: '100%',
          }"
        />
      </div>
    </div>

<!--    <Panel toggleable class="mt-4">-->
<!--      <template #header>-->
<!--        <h5 class="fw-bold">Примеры использования</h5>-->
<!--      </template>-->

<!--      <div>-->
<!--        <h5 class="fw-bold">1. Магазин проводит акцию, первые 100 пользователей которые заполнят анкету через бота получат скидку</h5>-->

<!--        <div class="p-2 custom-border bg-primary-subtle rounded">-->
<!--          <p>1. Заводим глобальную пользовательскую переменную "Количество доступных акций" и устанавливаем ее в значение 100</p>-->
<!--          <p>2. Заводим персональную пользовательскую переменную "Подписчик получил акцию", для защиты чтобы один подписчик получил одну акцию-->
<!--            (эту проверку можно так же реализовать через теги, завести тег получивших акцию и давать тег пользователю который получил акцию и проверять что у него еще нет тега)-->
<!--          </p>-->
<!--          <p>3. После заполнения всех необходимых данных - заполняем переменную из пункта 2 и уменьшаем значение переменной на 1 из пункта 1</p>-->
<!--        </div>-->


<!--        <a href="123">Ссылка на shared шаблон и ссылка на бота в который можно потыкаться и посмотреть функционал</a>-->
<!--      </div>-->

<!--      <div class="mt-4">-->
<!--        <h5 class="fw-bold">2. Выдача подарочного инфо-курса после приобретения 3 товаров</h5>-->

<!--        <div class="p-2 custom-border bg-primary-subtle rounded">-->
<!--          <p>1. </p>-->
<!--        </div>-->

<!--        <a href="123">Ссылка на shared шаблон и ссылка на бота в который можно потыкаться и посмотреть функционал</a>-->
<!--      </div>-->
<!--    </Panel>-->

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import Image from "primevue/image";
import OrganizationChart from "primevue/organizationchart";
import Panel from "primevue/panel";
import HelpInfo from "@/components/view/HelpInfo.vue";

export default defineComponent({
  name: "DocsContext",
  components: {
    HelpInfo,
    Image,
    OrganizationChart,
    Panel,
  },
  data: function () {
    return {
      variablesGraph: {
        label: 'Переменные',
        children: [
          {
            label: 'Системные',
            children: [
              {
                label: 'Глобальные'
              },
              {
                label: 'Персональные'
              }
            ]
          },
          {
            label: 'Пользовательские',
            children: [
              {
                label: 'Глобальные'
              },
              {
                label: 'Персональные'
              }
            ]
          },
        ]
      }
    }
  }
})
</script>

<!-- todo: иначе не подсвечивает линии -->
<style>
.p-organizationchart .p-organizationchart-line-top {
  border-top: 1px solid #e2e8f0;
}

.p-organizationchart .p-organizationchart-line-right {
  border-left: 1px solid #e2e8f0;
}
</style>